import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme } from '../../../styles';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      marginInline: 'auto',
      marginBottom: 40,
      maxWidth: '1012px',
      padding: '56px',
      background: '#F8F8F8',
      borderRadius: '8px',
      textAlign: 'center',
    },
    title: {
      fontSize: '42px',
      lineHeight: '50px',
      fontWeight: FontWeight.Medium,
      color: colors.secondary,
      margin: '0 auto 16px',
    },
    subTitle: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FontWeight.Medium,
      color: 'var(--x-text-color-2)',
      margin: '0 auto 32px',
    },
  }),
  {
    name: 'faq-short',
  },
);

export default useStyles;
